export default class videoplayer {
  constructor() {
    $('video').unbind('click').click(function(){
      if($(this).siblings('.video--sound').length){
        let willBeMuted = null;
        if(this.muted) {
          this.volume = 0.0;
          this.muted = false;
          willBeMuted = false;
          $(this).animate({'volume' : 1}, 200);
        } else {
          willBeMuted = true;
          $(this).animate({'volume' : 0}, 200, function(){
            this.muted = true;
          });
        }
        if(!willBeMuted) {
          $('video').not(this).each(function(){
            $(this).animate({'volume' : 0}, 200, function(){
              this.muted = true;
            });
            $(this).siblings('.video--sound').text('Unmute').removeClass('black');
          });
        }

        $(this).siblings('.video--sound').removeClass('force-out');

        if(willBeMuted) {
          $(this).siblings('.video--sound').text('Unmute').removeClass('black');
        } else {
          $(this).siblings('.video--sound').text('Mute').addClass('black');
        }

        var t = this;

        clearTimeout(this.time);
        this.time = setTimeout(function(){
          $(t).siblings('.video--sound').addClass('force-out');
        }, 900);
      }
    });

    $('.video--wrap').unbind('mousemove mouseleave').mousemove(function(){
      $(this).find('.video--sound').removeClass('force-out');

      clearTimeout(this.time);
      var t = this;
      this.time = setTimeout(function(){
        $(t).find('.video--sound').addClass('force-out');
      }, 900);
    }).mouseleave(function(){
      $(this).find('.video--sound').removeClass('force-out');
    });
  }
}
